import styled from "styled-components";

export const ProfilePageWrapper = styled.div`
  padding: 40px 60px;

  .profile-container {
    background-color: var(--border-color);
    height: 140px;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid var(--border-color);
  }
  .ant-typography-copy {
    color: #8a3ef4;
    font-size: 14px;
    margin-left: 6px;
  }
`;

export const PersonalInfoWrapper = styled.div`
  background-color: var(--primary-bg);
  padding: 20px;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  border-left: 5px solid #8a3ef4;

  .cardHeader {
    padding: 0px;
    .left-border {
      height: 50px;
      background-color: red;
      border-radius: 8px;
      border: 3px solid var(--border-color);
    }
    .heading {
      color: var(--primary-text-color);
      font-weight: 600;
      font-size: 18px;
      //   padding: 15px;
    }
    .subHeading {
      color: var(--primary-text-color);
      font-weight: 500;
      font-size: 12px;
      letter-spacing: 0.6px;
    }
  }

  .cardContainer {
    padding: 10px 30px 15px 30px;
    .subHeading {
      color: var(--secondary-text-color);
      font-size: 12px;
      font-weight: 600;
    }
    .data {
      color: var(--primary-text-color);
      font-size: 14px;
      font-weight: 600;
    }
  }

  .ant-input-affix-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 11px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 1.5715;
    background-color: var(--primary-bg);
    background-image: none;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    transition: all 0.3s;
    display: inline-flex;
  }

  .ant-input {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: "tnum", "tnum";
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 11px;
    // color: var(--text-primary) !important;
    font-size: 14px;
    line-height: 1.5715;
    background-image: none;
    border-radius: 6px;
    height: 40px;
    transition: all 0.3s;
  }
  .ant-input:focus,
  .ant-input:hover {
    border-color: #8a3ef4 !important;
    color: #000;
  }

  .ant-input-affix-wrapper-status-error:not(
      .ant-input-affix-wrapper-disabled
    ):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,
  .ant-input-affix-wrapper-status-error:not(
      .ant-input-affix-wrapper-disabled
    ):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {
    background: var(--primary-bg);
    border: 1px solid #ff4d4f !important;
  }

  .ant-input::placeholder {
    color: var(--secondary-text-color);
    font-size: 14px;
  }

  .ant-input-password-icon.anticon {
    color: var(--primary-text-color);
    cursor: pointer;
    transition: all 0.3s;
  }
  input:-webkit-autofill {
    box-shadow: 0 0 0 1000px var(--primary-bg) inset !important;
    -webkit-box-shadow: 0 0 0 1000px var(--primary-bg) inset !important;
    -webkit-text-fill-color: var(
      --primary-text-color
    ) !important; /* Optional: text color */
  }
  .ant-form-item{
    margin: 0 0 10px;
  }
  .ant-form-item-label{
    padding: 5px 0;
  }
  .ant-form-item-label > label{
    color: var(--primary-text-color);
  }
  .ant-progress-steps-item{
    width: 24.6% !important;
    border-radius: 10px !important;
  }
  .ant-table-pagination {
    margin: 55px 0 0;
  }
  .customZipSpin {
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 10px
  }
  .ant-select {
    color: var(--primary-text-color);
  }
  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #8a3ef4;
  }
  .ant-input-affix-wrapper-focused {
    border-color: #8a3ef4;
    box-shadow: none;
  }
`;
